export interface AppConfig {
    FRUITFUL_ENV: string;
    API_URL: string;
    API_PORT?: string;
    STYTCH_PUBLIC_TOKEN: string;
    SENDBIRD_APP_ID: string;
    LOGROCKET_MOBILE_APP_ID?: string;
    LOGROCKET_WEB_APP_ID?: string;
    SENTRY_DSN_MOBILE?: string;
    SENTRY_DSN_WEB?: string;
    STATSIG_TOKEN: string;
    MIXPANEL_TOKEN?: string;
    INACTIVITY_DURATION?: number;
    APPLE_APP_ID?: string;
    QUILTT_CONNECTOR_ID: string;
    CUSTOMERIO_SITE_ID: string;
    CUSTOMERIO_RN_WRITE_KEY?: string;
    CUSTOMERIO_WEB_WRITE_KEY?: string;
    LLM_SERVICE_BASE_URL: string;
    REACT_QUERY_DEVTOOLS_ENABLED?: string;
    STRIPE_PUBLISHABLE_KEY?: string;
}

// Load the appropriate environment file.
// Must use if statements over switch statement in order to ensure that ONLY the desired environment file is included in the bundle.
let config: AppConfig;
if (process.env.EXPO_PUBLIC_FRUITFUL_ENV === 'production') {
    // eslint-disable-next-line @typescript-eslint/no-require-imports,@typescript-eslint/no-unsafe-member-access
    config = require('./production').config as AppConfig;
} else if (process.env.EXPO_PUBLIC_FRUITFUL_ENV === 'staging') {
    // eslint-disable-next-line @typescript-eslint/no-require-imports,@typescript-eslint/no-unsafe-member-access
    config = require('./staging').config as AppConfig;
} else if (process.env.EXPO_PUBLIC_FRUITFUL_ENV === 'sandbox') {
    // eslint-disable-next-line @typescript-eslint/no-require-imports,@typescript-eslint/no-unsafe-member-access
    config = require('./sandbox').config as AppConfig;
} else if (process.env.EXPO_PUBLIC_FRUITFUL_ENV === 'test') {
    // eslint-disable-next-line @typescript-eslint/no-require-imports,@typescript-eslint/no-unsafe-member-access
    config = require('./test').config as AppConfig;
} else {
    // eslint-disable-next-line @typescript-eslint/no-require-imports,@typescript-eslint/no-unsafe-member-access
    config = require('./development').config as AppConfig;
}

export const {
    FRUITFUL_ENV,
    API_URL,
    API_PORT,
    STYTCH_PUBLIC_TOKEN,
    SENDBIRD_APP_ID,
    LOGROCKET_MOBILE_APP_ID,
    LOGROCKET_WEB_APP_ID,
    SENTRY_DSN_MOBILE,
    SENTRY_DSN_WEB,
    STATSIG_TOKEN,
    MIXPANEL_TOKEN,
    INACTIVITY_DURATION,
    APPLE_APP_ID,
    QUILTT_CONNECTOR_ID,
    CUSTOMERIO_SITE_ID,
    CUSTOMERIO_RN_WRITE_KEY,
    CUSTOMERIO_WEB_WRITE_KEY,
    LLM_SERVICE_BASE_URL,
    REACT_QUERY_DEVTOOLS_ENABLED,
    STRIPE_PUBLISHABLE_KEY,
} = config;
